module.exports = __webpack_public_path__ + "static/media/undraw-logistics-x-4-dc.d85057f0.svg";